/**
 * @file:
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-09-21 16:29:06
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-04-16 18:40:10
 * @FilePath: /console-znzs/new_src/api/index.js
 */
import request from '@/znzs/src/utils/request';
import Cookies from 'js-cookie';

/**
 * 使用调研
 * @deprecated
 * https://yapi.baidu-int.com/project/18492/interface/api/2680030
 */
export const usedResearch = data => request.post('/evaluate/research', data);

/**
 * 根据productId获取对应产品的退款规则
 * @param {*} serviceType
 * @returns
 * https://yapi.baidu-int.com/project/18492/interface/api/2822435
 */
export const checkRefund = serviceType => request.get('/refund-rule-by-product', {params: {serviceType}});

/**
 * 查询用户是否完成实名认证
 * @returns
 * https://yapi.baidu-int.com/project/18492/interface/api/2914707
 */
export const checkRealname = () => request.get('/common/realname-qualification');
/**
 * 查询用户是否开通了大模型服务
 * @returns
 * https://yapi.baidu-int.com/project/18492/interface/api/2914716
 */
export const checkLLMNumber = () => request.get('/common/llm-activate');
/**
 * 提交大模型服务产品咨询卡片的预填信息
 * @returns
 * https://yapi.baidu-int.com/project/18492/interface/api/2914720
 */
export const confirmQfForm = data => request.post('/im-dialogs/llm-sp-info', data);

/**
 * 用户是否有历史会话记录
 * @deprecated
 * @returns
 */
export const getSessionRecord = () => request.get('/im-sessions/has-record');

/**
 * 提单卡片中的优选服务推广
 * @returns
 */
export const getPromote = params => request.get('/recommend/product-promote', {params});

/**
 * 用户手动停止生成
 * @param {*} dialogId
 * @returns
 */
export const stopGenerateByUser = dialogId => request.put(`/dialog/${dialogId}/stream-interrupt`);

/**
 * 语音转文字
 * @param {*} formData
 * @returns
 */
export const speechToText = formData => request.post('/common/speech-to-text', formData);

/**
 * 自动生成提单信息
 * @returns
 */
export const generateTicketInfo = () => request.get('/common/question-generate');

/**
 * 上传图片
 * @returns
 */
export const uploadImage = formData => {
    const headers = {
        'csrftoken': Cookies.get('bce-user-info'),
    };
    return request.post('/file/upload', formData, {headers});
};

/**
 * 获取当前会话是否有有效对话
 * @returns
 */
export const getEffectiveDialog = () => request.get('/session/has-effective-dialog');

/**
 * 获取历史会话列表
 * @description https://iapi.baidu-int.com/web/project/348648/apis/api-4757160
 * @returns
 */
export const getSessionHistory = params => request.get('/session/list-simple-sessions', {params});

/**
 * 查询历史会话记录
 * @description https://iapi.baidu-int.com/web/project/348648/apis/api-4757160
 * @param {*} sessionId
 * @returns
 */
export const getSessionMessages = sessionId => request.get('/session-dialogs', {params: {sessionId}});

/**
 * 创建会话
 * @description https://iapi.baidu-int.com/web/project/348648/apis/api-4757112
 * @returns
 */
export const closeCurrentSession = () => request.post('/session/close-session');
